/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Created_By_LabelInputs */

const en_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created By:`)
};

const fr_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé par :`)
};

const de_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt von:`)
};

const it_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato da:`)
};

const ru_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создано:`)
};

const es_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado por:`)
};

const zh_cn2_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建者：`)
};

const ja_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成者:`)
};

const hi_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के द्वारा बनाई गई:`)
};

const pt_pt2_knp_guide_created_by_label = /** @type {(inputs: Knp_Guide_Created_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado por:`)
};

/**
* | output |
* | --- |
* | "Created By:" |
*
* @param {Knp_Guide_Created_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_created_by_label = /** @type {((inputs?: Knp_Guide_Created_By_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Created_By_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_created_by_label(inputs)
	if (locale === "de") return de_knp_guide_created_by_label(inputs)
	if (locale === "it") return it_knp_guide_created_by_label(inputs)
	if (locale === "ru") return ru_knp_guide_created_by_label(inputs)
	if (locale === "es") return es_knp_guide_created_by_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_created_by_label(inputs)
	if (locale === "ja") return ja_knp_guide_created_by_label(inputs)
	if (locale === "hi") return hi_knp_guide_created_by_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_created_by_label(inputs)
	return en_knp_guide_created_by_label(inputs)
});